/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useCallback, useContext, memo } from 'react';

import initialActions from './actions';

import { IState, IActions } from './dtos';

import { initialState } from './constants';

interface IData {
  data: IState;
  actions: IActions;
}

export const SpecSheetsContext = React.createContext<IData>({
  data: initialState,
  actions: initialActions({ data: initialState, setData: () => {} }),
});

export const useSpecSheets = (): IData => useContext(SpecSheetsContext);

export default function withSpecSheetsProvider(
  WrappedComponent: React.FC,
  state: IState = initialState,
  actions = initialActions,
): React.FC {
  const WithSpecSheets = (props: any) => {
    const [data, setData] = useState(state);

    const value = useCallback(
      () => ({
        data,
        actions: actions({ data, setData }),
      }),
      [data],
    );

    const dataValue: IData = value();

    return (
      <SpecSheetsContext.Provider value={dataValue}>
        <WrappedComponent {...props} />
      </SpecSheetsContext.Provider>
    );
  };

  return memo(WithSpecSheets);
}
